module.exports = __webpack_public_path__ + "img/Logo_ActorsChallenge-31.75c4b6aa.svg";